<template>
<mdb-container>
    <mdb-modal :show="getToggle" @close="toggleLogin(false)" cascade tabs>
        <mdb-tab tabs justify class="bg-info darken-3">
            <mdb-tab-item :active="tabs==1" @click.native.prevent="tabs = 1" class="text-white">
                <mdb-icon icon="user" class="mr-1 text-white" />Login</mdb-tab-item>
            <mdb-tab-item :active="tabs==2" @click.native.prevent="tabs = 2" class="text-white">
                <mdb-icon icon="user-plus" class="mr-1 text-white" />Register</mdb-tab-item>
        </mdb-tab>

        <!-- Login -->
        <mdb-modal-body class="mx-3" v-if="tabs==1">
            <mdb-input label="Your email" type="email" class="mb-5" v-model="login.email" />
            <div v-if="login.submit &&  (!$v.login.email.required || !$v.login.email.email)" class=" text-center mt-n5">
                <small class="text-danger">Favor de Chequear Correo Electronico!</small>
            </div>

            <mdb-input label="Your password" type="password" v-model="login.password" />
            <div v-if="login.submit && (!$v.login.password.required || !$v.login.password.minLength)" class="mt-n3 text-center">
                <small v-if="!$v.login.password.required" class="text-danger">Contraseña Requerida!</small>
                <small v-else-if="!$v.login.password.minLength" class="text-danger">Contraseña debe ser 8 caracteres minimo!</small>
            </div>

            <div class="mt-2 text-center">
                <mdb-btn @click="logIn('email')" color="info">Log in
                    <mdb-icon icon="sign-in-alt" class="ml-1" />
                </mdb-btn>
            </div>

            <div class="d-flex justify-content-center mt-3"> - O -</div>

            <div class="d-flex justify-content-center row pt-4">
                <mdb-btn @click="signUp('facebook')" class="btn-fb aqua-gradient" icon="facebook-f" fab>Facebook</mdb-btn>
                <mdb-btn @click="signUp('google')" class="btn-google aqua-gradient" icon="google" fab>Google</mdb-btn>
            </div>

             <small class="text-danger">{{login.auth_error_message}}</small>
        </mdb-modal-body>
        <mdb-modal-footer center v-if="tabs==1">
            <div class="options text-center text-md-right mt-1">
                <p>No estas registrado? <a href="#" @click="tabs=2">Registrate</a></p>
                <p>Olvido la <a href="#">Contraseña?</a></p>
            </div>
            <mdb-btn outline="info" class="ml-auto" @click.native="toggleLogin(false)">Close</mdb-btn>
        </mdb-modal-footer>

        <!-- Sign Up -->
        <mdb-modal-body class="mx-3" v-if="tabs==2">
            <mdb-input label="Correo Electronico" type="email" class="mb-5" v-model="register.email" />
            <div v-if="register.submit &&  (!$v.register.email.required || !$v.register.email.email)" class=" text-center mt-n5">
                <small class="text-danger">Favor de Chequear Correo Electronico!</small>
            </div>

            <mdb-input label="Contraseña" :type="passwordFieldType" class="mb-5" v-model="register.password" />
            <div class="progress  mt-n5 " v-show="$v.register.password.required">
                <div v-if="password_strength < 25 && $v.register.password.required" class="progress-bar btn-danger  progress-bar-striped" role="progressbar" style="width: 25%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">Very Weak</div>
                <div v-if="password_strength >= 25 && password_strength < 50" class="progress-bar progress_2  progress-bar-striped" role="progressbar" style="width: 50%" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100">Weak</div>
                <div v-if="password_strength >= 50 && password_strength < 75 " class="progress-bar progress_3  progress-bar-striped" role="progressbar" style="width: 75%" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100">Medium</div>
                <div v-if="password_strength >=75" class="progress-bar progress_4 progress-bar-striped" role="progressbar  " style="width: 100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">Strong</div>
            </div>
            <div v-if="register.submit && (!$v.register.password.required || !$v.register.password.minLength)" class="mt-n5 text-center">
                <small v-if="!$v.register.password.required" class="text-danger">Contraseña Requerida!</small>
                <small v-else-if="!$v.register.password.minLength" class="text-danger">Contraseña debe ser 8 caracteres minimo!</small>
            </div>

            <mdb-input label="Repite Contraseña" :type="passwordFieldType" v-model="$v.register.password2.$model" />
            <div v-if="register.submit && (!$v.register.password2.required || !$v.register.password2.minLength || !$v.register.password2.sameAs)" class="mt-n3 text-center">
                <small v-if="!$v.register.password2.required" class="text-danger">Contraseña Requerida!</small>
                <small v-else-if="!$v.register.password2.minLength" class="text-danger">Contraseña debe ser 8 caracteres minimo!</small>
                <small v-else-if="!$v.register.password2.sameAsPassword" class="text-danger">Contraseña no machea!</small>
            </div>

            <div class="d-flex justify-content-end mt-n4">
                <a v-if='passwordFieldType === "password"' @click="switchVisibility"><i class="fas fa-eye"></i></a>
                <a v-if='passwordFieldType === "text"' @click="switchVisibility"><i class="fas fa-eye-slash"></i></a>
            </div>

            <div class="mt-2 text-center">
                <mdb-btn @click="signUp('email')" color="info">Registrate
                    <mdb-icon icon="sign-in-alt" class="ml-1" />
                </mdb-btn>
            </div>

            <div class="d-flex justify-content-center mt-3"> - O -</div>

            <div class="d-flex justify-content-center row pt-4">
                <mdb-btn @click="signUp('facebook')" class="btn-fb aqua-gradient" icon="facebook-f" fab>Facebook</mdb-btn>
                <mdb-btn @click="signUp('google')" class="btn-google aqua-gradient" icon="google" fab>Google</mdb-btn>
            </div>

            <small class="text-danger">{{register.auth_error_message}}</small>

        </mdb-modal-body>
        <mdb-modal-footer center v-if="tabs==2">
            <div class="options text-center text-md-right mt-1">
                <p>Ya estas Registrado? <a href="#" @click="tabs=1">Log in</a></p>
            </div>
            <mdb-btn outline="info" class="ml-auto" @click.native="toggleLogin(false)">Close</mdb-btn>
        </mdb-modal-footer>
    </mdb-modal>
</mdb-container>
</template>

<script>
import {
    mdbContainer,
    mdbBtn,
    mdbModal,
    mdbTab,
    mdbTabItem,
    mdbModalBody,
    mdbInput,
    mdbModalFooter,
    mdbIcon
} from 'mdbvue';
import {
    required,
    minLength,
    email,
    sameAs
} from 'vuelidate/lib/validators' //sameAs

import store from '../store/index'
import firebase from 'firebase'
export default {
    name: 'ModalExamplesPage',
    components: {
        mdbContainer,
        mdbBtn,
        mdbModal,
        mdbTab,
        mdbTabItem,
        mdbModalBody,
        mdbInput,
        mdbModalFooter,
        mdbIcon,

    },
    data() {
        return {
            cascading: false,
            tabs: 1,
            passwordFieldType: 'password',
            register: {
                email: '',
                password: '',
                password2: '',
                submit: false,
                auth_error_message: null,
            },
            login: {
                email: '',
                password: '',
                submit: false,
                auth_error_message: null,
            }
        }
    },
    validations: {
        register: {
            email: {
                required,
                email,
                minLength: minLength(8)
            },
            password: {
                required,
                minLength: minLength(8)
            },
            password2: {
                required,
                minLength: minLength(8),
                sameAsPassword: sameAs('password')
            },
        },
        login: {
            email: {
                required,
                email,
                minLength: minLength(8)
            },
            password: {
                required,
                minLength: minLength(8)
            },

        },
    },
    methods: {
        toggleLogin(b) {
            store.commit('toggleLogin', b)
        },
        switchVisibility() {
            this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
        },
        signUp(p) {
            if (p === 'email') {
                this.register.submit = true
                this.$v.$touch();
                if (this.$v.register.$invalid) {
                    this.register.submit = true
                    return;
                }
                firebase.auth().createUserWithEmailAndPassword(this.register.email, this.register.password).then((user) => {
                    user
                    console.log(user)
                    this.$notify.info({
                        message: 'Te has registrado con ' + this.register.email + '.',
                        position: 'bottom full width',
                        timeOut: 3000
                    });
                    this.toggleLogin(false)
                    // store.commit('toggleMLogin', false)
                    this.register.submit = false
                }).catch((err) => {
                    switch (err.code) {
                        case 'auth/email-already-in-use':
                            this.register.auth_error_message = 'Correo electronico ya Registrado'
                            break;
                        case 'auth/invalid-email':
                            this.register.auth_error_message = 'Correo electronico no es valido'
                            break;
                        case 'auth/operation-not-allowed':
                            this.register.auth_error_message = 'Cuenta Desactivada'
                            break;
                        case 'auth/weak-password':
                            this.register.auth_error_message = 'Contraseña Debil'
                            break;
                        default:
                            this.register.auth_error_message = ''
                    }

                })
            } else {
                var provider = ''
                switch (p) {
                    case 'google':
                        provider = new firebase.auth.GoogleAuthProvider();
                        break;
                    case 'facebook':
                        provider = new firebase.auth.FacebookAuthProvider();
                }
                firebase.auth().signInWithPopup(provider).then((result) => {
                        result
                        this.$notify.info({
                            message: 'You have successfully signed up with ' + provider.providerId + '.',
                            position: 'bottom full width',
                            timeOut: 3000
                        });
                        this.toggleLogin(false)

                        this.register.submit = false
                    })
                    .catch((err) => {
                        err
                        this.register.submit = false
                    })
            }
        },
        logIn(p) {
            if (p === 'email') {
                this.login.submit = true
                this.$v.$touch();
                if (this.$v.login.$invalid) {
                    console.log('Invalid')
                    this.login.submit = true
                    return;
                }
                firebase.auth().signInWithEmailAndPassword(this.login.email, this.login.password).then((user) => {
                    console.log(user)
                    user
                    this.$notify.info({
                        message: 'Has entrado exitosamente ' + this.register.email + '.',
                        position: 'bottom full width',
                        timeOut: 3000
                    });
                    this.toggleLogin(false)
                    this.login.submit = false
                }).catch((err) => {
                    console.log(err)
                    switch (err.code) {
                        case 'auth/account-exists-with-different-credential':
                            this.login.auth_error_message = 'Cuanta existe bajo otros credenciales'
                            break;
                        case 'auth/user-not-found':
                            this.login.auth_error_message = 'Usuario no Existe'
                            break;
                        case 'auth/user-disabled':
                            this.login.auth_error_message = 'Cuenta Desactivada'
                            break;
                        case 'auth/wrong-password':
                            console.log("asjkdkasjdkasjdk")
                            this.login.auth_error_message = 'Usuario o contraseña incorrectos'
                            break;
                        case 'auth/email-already-in-use':
                            this.login.auth_error_message = 'Correo electronico ya Registrado'
                            break;
                        case 'auth/invalid-email':
                            this.login.auth_error_message = 'Correo electronico no es valido'
                            break;
                        case 'auth/operation-not-allowed':
                            this.login.auth_error_message = 'Cuenta Desactivada'
                            break;
                        case 'auth/weak-password':
                            this.login.auth_error_message = 'Contraseña Debil'
                            break;
                        default:
                            this.login.auth_error_message = ''
                    }

                })
            }
        }
    },
    computed: {
        getToggle() {
            return store.state.loginModal
        },
        password_strength() {
            let score = 0;
            if (this.register.password === '') return score;

            let letters = {};
            for (let i = 0; i < this.register.password.length; i++) {
                letters[this.register.password[i]] = (letters[this.register.password[i]] || 0) + 1;
                score += 5.0 / letters[this.register.password[i]];
            }

            let variations = {
                digits: /\d/.test(this.register.password),
                lower: /[a-z]/.test(this.register.password),
                upper: /[A-Z]/.test(this.register.password),
                special: /\W/.test(this.register.password)
            }

            let variationCount = 0;
            for (let check in variations) {
                variationCount += (variations[check] == true) ? 1 : 0;
            }

            score += (variationCount - 1) * 10;
            return parseInt(score);
        },
    }
}
</script>

<style lang="css">
.md-tabs .nav-link {
    color: white !important;
}

.progress {
    border-radius: unset;
}

.progress_1 {
    background-color: #E40808;
}

.progress_2 {
    background-color: #E17D30;
}

.progress_3 {
    background-color: #F0B03F;
}

.progress_4 {
    background-color: #A5DF41;
}

input {
    text-indent: 5px;
}
</style>
